import { PipetteIcon } from "app/components/Icons";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import React from "react";
import { fixedTagsColorCode } from "./data";
import ColorPlate from "./TagsColorPlate";
import { ColorPickerProps } from "./types";



const TagsColorPicker: React.FC<ColorPickerProps> = ({
  trigger,
  selectedColor,
  updateCode,
  setOpen,open
}) => {


  return (
    <div className=" relative ">
      <Popover open={open} onOpenChange={setOpen} modal={false}>
        <PopoverTrigger asChild>{trigger}</PopoverTrigger>
        <PopoverContent
          align="start"
          alignOffset={50}
          sideOffset={4}
          className="bg-white border border-gray-100 cursor-pointer w-[192px] !px-2.5 !py-2"
          onOpenAutoFocus={(e) => e.preventDefault()}
          onCloseAutoFocus={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
          onPointerDownOutside={(e) => e.preventDefault()}
          onFocusOutside={(e) => e.preventDefault()}
        >
          <div className="flex flex-wrap gap-2">
            {fixedTagsColorCode.map((color, index) => (
              <div
                key={index}
                className={`${
                  color === selectedColor
                    ? ` border rounded-full flex justify-center items-center size-5 `
                    : ""
                }  `}
                style={{ borderColor: selectedColor }}
              >
                <div
                  className="w-[16px] h-[16px] rounded-full cursor-pointer"
                  style={{ backgroundColor: color }}
                  onClick={() => {
                    updateCode(color);
                    setOpen(false);
                  }}
                />
              </div>
            ))}
            <ColorPlate
              trigger={
                <button className="w-[16px] h-[16px] rounded-full cursor-pointer flex items-center justify-center relative">
                  <PipetteIcon />
                </button>
              }
              color={selectedColor}
              updateColor={updateCode}
            />
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default TagsColorPicker;
